import validateItems from "./validateItems";
import validateRequestOptions from "../validateRequestOptions";
import validateGetAuthorisationDelegate from "../validateGetAuthorisationDelegate";
import { DEFAULT_LIST_ITEMS_URL_PATH } from "../constants";

/**
 * Add multiple items to saved items
 * @memberof module:sdkInstance
 * @inner
 * @param {Object} params
 * @param {Object[]} params.items item to add to saved items. one of colourWayId or variantId is required.
 * @param {number} params.items[].productId product id
 * @param {number} [params.items[].colourWayId] colour way id
 * @param {number} [params.items[].variantId] variant id
 * @param {requestOptions} [params.requestOptions] request options
 * @return {Promise<external:API.ItemAddedResponse>} Promise resolving to ItemAddedResponse.
 * @throws {TypeError} only one of variantId or colourWayId should be supplied.
 * @throws {TypeError} configuration.{@link getAuthorisationDelegate|getAuthorisation} is required, since this is an authorised endpoint.
 * @see {@link https://redoc-service.asoscloud.com/files/AWG/master/customer-saveditems-v3.html#operation/Add Saved Item(s)|API Documentation}
 * @example
 * sdk.addItems({ items: [{ productId: 1234543, colourWayId: 4865244 }, { productId: 1231334, variantId: 223433 }] });
 */
const addItems = (
  {
    api,
    context: { currency, keyStoreDataversion, lang, sizeSchema, store },
    configuration: { getAuthorisation } = {}
  },
  { items, requestOptions } = {}
) => {
  validateGetAuthorisationDelegate(getAuthorisation);
  validateItems(items);
  validateRequestOptions(requestOptions);
  return api.post({
    path: DEFAULT_LIST_ITEMS_URL_PATH,
    body: { items },
    queryParams: {
      currency,
      keyStoreDataversion,
      lang,
      sizeSchema,
      store
    },
    requestOptions
  });
};

export default addItems;
